/// <amd-module name="Wit/Common/Utils/WorkItemUtils/extractInfoFromControlMetadata" />
const relatedWorkItem = "Related Workitem";

// Using window.DOMParser and not DOMParser because jest only stubs the former
const xmlParser = new window.DOMParser();

const linkDirectionSuffixes = ["-Forward", "-Reverse"];

export interface ILinksControlInfo {
    zeroDataExperience: string;
    columns?: string[];
    compact: boolean;
    allowedLinkTypes: Set<string>;
    allowedWitLinkTypeEnds: Set<string>;
    allowedWorkItemTypes: Set<string>;
}

export function extractInfoFromControlMetadata(metadata: string): ILinksControlInfo {
    const metadataDocument = xmlParser.parseFromString(metadata, "text/xml");

    const viewMode = metadataDocument.querySelector("LinksControlOptions")?.getAttribute("ViewMode");
    const compact = viewMode ? ["List", "Dynamic"].includes(viewMode) : true;

    const allowedLinkTypes = new Set<string>();
    metadataDocument.querySelectorAll("ExternalLinkFilter").forEach(node => {
        const linkType = node.getAttribute("Type");
        if (linkType) {
            allowedLinkTypes.add(linkType);
        }
    });

    const allowedWitLinkTypeEnds = new Set<string>();
    metadataDocument.querySelectorAll("WorkItemLinkFilter").forEach(node => {
        const witLinkType = node.getAttribute("Type");
        if (witLinkType) {
            allowedLinkTypes.add(relatedWorkItem);
            allowedWitLinkTypeEnds.add(witLinkType);

            if (!linkDirectionSuffixes.some(suffix => witLinkType.endsWith(suffix))) {
                linkDirectionSuffixes.forEach(suffix => allowedWitLinkTypeEnds.add(witLinkType + suffix));
            }
        }
    });

    const allowedWorkItemTypes = new Set<string>();
    metadataDocument.querySelectorAll("WorkItemTypeFilters").forEach(filtersNode => {
        filtersNode.querySelectorAll("Filter").forEach(filterNode => {
            const workItemType = filterNode.getAttribute("WorkItemType");
            if (workItemType) {
                allowedWorkItemTypes.add(workItemType);
            }
        });
    });

    const zeroDataExperience = metadataDocument.querySelector("LinksControlOptions")?.getAttribute("ZeroDataExperience") ?? "RelatedWork";

    const columnNames: string[] = [];
    metadataDocument.querySelectorAll("Column").forEach(node => {
        const columnName = node.getAttribute("Name");
        if (columnName) {
            columnNames.push(columnName);
        }
    });
    const columns = columnNames.length > 0 ? columnNames : undefined;

    return { zeroDataExperience, columns, compact, allowedLinkTypes, allowedWitLinkTypeEnds, allowedWorkItemTypes };
}
